import { useMutation, useQueryClient } from '@tanstack/react-query';

import { markBadgeSeen } from '../services';

export function useAcknowledgeBadge() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: markBadgeSeen,
    onSuccess: () => {
      queryClient.setQueriesData<number>({ queryKey: ['notifications', 'badge-count'] }, 0);
    },
  });
}
